/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import {
  BaseApiClient,
  RequestContext,
  ApiConfigManager,
  HttpRequestState
} from '@sg/api/base-api-lib';
import { BroadcastApiConfig } from '../api-config';

import { BroadcastApi } from '../models';

@Injectable()
export class BroadcastApiClient extends BaseApiClient<BroadcastApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.broadcastApiConfig);
  }

  broadcastControllerGetValidBroadcastChannels(options?: {
    observe?: 'bodyPromise';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Promise<Array<any>>;
  broadcastControllerGetValidBroadcastChannels(options?: {
    observe: 'responsePromise';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Promise<HttpResponse<Array<any>>>;
  broadcastControllerGetValidBroadcastChannels(options?: {
    observe: 'body';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<Array<any>>;
  broadcastControllerGetValidBroadcastChannels(options?: {
    observe: 'bodyWithState';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<HttpRequestState<Array<any>>>;
  broadcastControllerGetValidBroadcastChannels(options?: {
    observe: 'response';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<HttpResponse<Array<any>>>;
  broadcastControllerGetValidBroadcastChannels(options?: {
    observe: 'events';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<HttpEvent<Array<any>>>;
  broadcastControllerGetValidBroadcastChannels(
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<Array<any>>(
      `${this.basePath}/gateway/admin/broadcast/channels`,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  broadcastControllerGetAvailableTransmissionInstructions(options?: {
    observe?: 'bodyPromise';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Promise<Array<BroadcastApi.SelectOption>>;
  broadcastControllerGetAvailableTransmissionInstructions(options?: {
    observe: 'responsePromise';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Promise<HttpResponse<Array<BroadcastApi.SelectOption>>>;
  broadcastControllerGetAvailableTransmissionInstructions(options?: {
    observe: 'body';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<Array<BroadcastApi.SelectOption>>;
  broadcastControllerGetAvailableTransmissionInstructions(options?: {
    observe: 'bodyWithState';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<HttpRequestState<Array<BroadcastApi.SelectOption>>>;
  broadcastControllerGetAvailableTransmissionInstructions(options?: {
    observe: 'response';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<HttpResponse<Array<BroadcastApi.SelectOption>>>;
  broadcastControllerGetAvailableTransmissionInstructions(options?: {
    observe: 'events';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<HttpEvent<Array<BroadcastApi.SelectOption>>>;
  broadcastControllerGetAvailableTransmissionInstructions(
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<Array<BroadcastApi.SelectOption>>(
      `${this.basePath}/gateway/admin/broadcast/instructions`,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  broadcastControllerGetValidDataObjectTemplateTags(options?: {
    observe?: 'bodyPromise';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Promise<Array<BroadcastApi.DataTemplateTag>>;
  broadcastControllerGetValidDataObjectTemplateTags(options?: {
    observe: 'responsePromise';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Promise<HttpResponse<Array<BroadcastApi.DataTemplateTag>>>;
  broadcastControllerGetValidDataObjectTemplateTags(options?: {
    observe: 'body';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<Array<BroadcastApi.DataTemplateTag>>;
  broadcastControllerGetValidDataObjectTemplateTags(options?: {
    observe: 'bodyWithState';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<HttpRequestState<Array<BroadcastApi.DataTemplateTag>>>;
  broadcastControllerGetValidDataObjectTemplateTags(options?: {
    observe: 'response';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<HttpResponse<Array<BroadcastApi.DataTemplateTag>>>;
  broadcastControllerGetValidDataObjectTemplateTags(options?: {
    observe: 'events';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<HttpEvent<Array<BroadcastApi.DataTemplateTag>>>;
  broadcastControllerGetValidDataObjectTemplateTags(
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<Array<BroadcastApi.DataTemplateTag>>(
      `${this.basePath}/gateway/admin/broadcast/dataObjectTemplateTags`,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
